module.exports = __webpack_public_path__ + "static/ITSecurity-ef57e5cda5707f4d096c40dfd1dfee8a.png";